module.exports = __webpack_public_path__ + "static/media/chevromLeft.15ec7852.svg";